import {getSubDomain} from "./getFirstPathnameSegment";

// Ant Design magenta-6 — identisch zum Stage-Header (@colorPimaryStage in app.less).
const STAGE_PINK = "#eb2f96";

/**
 * Färbt das Favicon auf Stage magenta ein, damit ein Stage-Tab schon am Browser-Icon
 * erkennbar ist. Rein clientseitig (Stage und Prod teilen sich denselben Build): getönt
 * per Canvas aus dem bestehenden Logo, daher kein zweites Asset nötig. Nur auf Stage aktiv
 * (`hostname` beginnt mit `stage.`), sonst No-op.
 */
export const setStageFavicon = (): void => {
    if (getSubDomain() !== "stage") return;

    const icons = document.querySelectorAll<HTMLLinkElement>('link[rel="icon"]');
    if (icons.length === 0) return;

    const img = new Image();
    img.addEventListener("load", () => {
        const canvas = document.createElement("canvas");
        canvas.width = img.naturalWidth || 32;
        canvas.height = img.naturalHeight || 32;
        const ctx = canvas.getContext("2d");
        if (!ctx) return;

        ctx.drawImage(img, 0, 0);
        // Nur die Alpha-Silhouette des Logos behalten und mit Stage-Pink füllen.
        ctx.globalCompositeOperation = "source-in";
        ctx.fillStyle = STAGE_PINK;
        ctx.fillRect(0, 0, canvas.width, canvas.height);

        const dataUrl = canvas.toDataURL("image/png");
        icons.forEach((link) => {
            link.href = dataUrl;
        });
    });

    // Größte Quelle (256×256) bevorzugen, sonst das erste Icon — same-origin, kein CORS-Taint.
    const hiRes = document.querySelector<HTMLLinkElement>('link[rel="icon"][sizes="256x256"]');
    img.src = (hiRes || icons[0]).href;
};
